import styled from "styled-components";

export const DrawerContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 328px;
  @media (max-width: 576px) {
    width: 100%;
  }
  .top-fixed-section {
    background: ${({ theme }) => theme.styleGuide.colors.white};
    z-index: 1;
    @media (max-width: 576px) {
      border-bottom: 1px solid
        ${({ theme }) => theme.styleGuide.colors.gray[400]};
    }
  }

  #middle-scrollable-section {
    height: 100%;
    @media (min-width: 576px) {
      height: 52vh;
    }
    position: relative;
    overflow-y: scroll;
  }

  @-moz-document url-prefix() {
    #middle-scrollable-section {
      height: 55vh;
    }
  }

  .add-comparison {
    height: 51px;
    border-bottom: 1px solid ${({ theme }) => theme.styleGuide.colors.gray[400]};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.styleGuide.colors.blue[500]};
    background: ${({ theme }) => theme.styleGuide.colors.gray[300]};
    cursor: pointer;
    font-weight: 500;
  }

  .footer-content {
    display: flex;
    align-self: flex-end;
    margin-top: auto;
    padding: 15px;
    background: ${({ theme }) => theme.styleGuide.colors.white};
    z-index: 1;

    button {
      margin-right: 10px;
    }
  }

  .reset-default {
    display: flex;
    align-self: center;
    padding: 12px 0;
    color: ${({ theme }) => theme.styleGuide.colors.blue[500]};
    cursor: pointer;
    justify-content: center;
  }

  .search-for-fields {
    height: 51px;
    border-bottom: 1px solid ${({ theme }) => theme.styleGuide.colors.gray[400]};

    .search-box-wrapper {
      height: 34px;
      display: flex;
      flex-direction: row;
      justify-items: center;
      margin: 10px 10px;
      .close-icon {
        position: absolute;
        right: 1em;
        height: 26px;
        margin-top: 4px;
        z-index: 999;
        fill: ${({ theme }) => theme.styleGuide.colors.blue[600]};
        @media (max-width: 576px) {
          display: none;
        }
      }
      .search-box {
        margin-right: 2px;
        background: ${({ theme }) => theme.styleGuide.colors.blue[100]};
      }
      .cancel-button {
        text-decoration: none;
        line-height: 34px;
        padding: 0em 1em;
        color: ${({ theme }) => theme.styleGuide.colors.blue[500]};
        text-align: right;
        @media (max-width: 576px) {
          display: inline-block;
        }
        @media (min-width: 576px) {
          display: none;
        }
      }
    }
    .fields-list {
      @media (min-width: 576px) {
        max-height: 220px;
      }
      @media (max-width: 576px) {
        max-height: 84vh;
        border: none;
        margin: 0;
        font-weight: 500;
      }
      overflow: scroll;
      margin: 0 10px;
      border: 1px solid ${({ theme }) => theme.styleGuide.colors.gray[400]};
      border-radius: 0.4rem;
      top: -7px;
      position: relative;
      background: ${({ theme }) => theme.styleGuide.colors.white};
      padding: 6px;
      z-index: 1;

      .search-result {
        display: flex;
        justify-content: space-between;
        padding: 11px;
        cursor: pointer;
        border-radius: 0.4rem;
      }
      .search-result > div:last-child {
        color: ${({ theme }) => theme.styleGuide.colors.purple[500]};
      }
      .search-result: hover {
        background: ${({ theme }) => theme.styleGuide.colors.gray[400]};
      }
      .no-search-result {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 2em;
        min-height: 100px;
        border-radius: 0.4rem;
        text-align: center;
      }
    }
  }
`;

export const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;

  h3 {
    padding: 20px 0 20px 15px;
  }
`;

export const ActiveList = styled.div`
  display: flex;
  border-bottom: 0.1rem solid
    ${({ theme }) => theme.styleGuide.colors.gray[400]};
  align-items: center;

  &:active {
    border: 0.1rem solid ${({ theme }) => theme.styleGuide.colors.gray[400]};
    margin: -1px -1px 0;
  }

  &:hover > div:nth-child(1),
  &:active > div:nth-child(1),
  &:hover > div:nth-child(4),
  &:active > div:nth-child(4) {
    visibility: visible;
  }

  div:nth-child(1),
  div:nth-child(4) {
    text-align: center;
    width: 8%;
    visibility: hidden;

    ${({ theme }) => theme.media.sm`
    visibility: visible;
  `};
  }
  div:nth-child(2) {
    width: 54%;
    padding-left: 2px;
  }

  div:nth-child(4) {
    cursor: pointer;
  }
  div:nth-child(3) {
    width: 30%;
    padding-right: 2rem;
  }

  input {
    height: 32px;

    text-align: right;
  }
`;

export const PhotoWidgetContainer = styled.div`
  width: 100%;
  height: 210px;

  #photo {
    width: 100px;
  }
`;

export const PhotoCellContainer = styled.div`
  position: relative;
  width: 100%;
  height: 210px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
`;

export const DeleteWrapper = styled.div`
  display: flex;
  height: 45px;
  padding: 6px 0;
  justify-content: flex-end;
  border-bottom: 0.1rem solid
    ${({ theme }) => theme.styleGuide.colors.gray[400]};
  height: 45px;
  button {
    height: 34px;
    line-height: 1.3rem;
    margin-right: 10px;
  }
`;

export const ResetToDefaultContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 500px;
  flex-direction: column;

  h3,
  .end-of-block {
    margin-bottom: 23px;
  }

  button {
    height: 34px;
    line-height: 1.3rem;
    margin-right: 10px;
  }
`;
